var React = require('react');

function Scala (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 14V6.05556C19.4444 6.05556 26.1852 2.68519 28 1V8.94444C26.7556 12.4111 13.4815 13.7593 7 14Z","fill":"#5B59FB","key":0}),React.createElement("path",{"d":"M7 24V15.5882C19.4444 15.5882 26.1852 12.7843 28 11V19.4118C26.7556 23.0824 13.4815 23.7451 7 24Z","fill":"#5B59FB","key":1}),React.createElement("path",{"d":"M7 34V25.9584C19.4444 25.9584 26.1852 23.7058 28 22V29.6137C26.7556 33.1227 13.4815 33.7563 7 34Z","fill":"#5B59FB","key":2})]);
}

Scala.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Scala;

Scala.default = Scala;
